export default __webpack_public_path__ + "static/31-7d497822414353ccb7e90e83f84c98d8.png";